<wms-dialog-header title="{{locale[dialogTitleKey]}}" (onClose)="closeDialog('uploadResourcesDialog')"></wms-dialog-header>
<wms-dialog-body>
  <form name="resourceUploadForm" enctype="multipart/form-data">
    <wms-message name="uploadMessage" [scopeDataset]="uploadMessage"></wms-message>
    <div>
      <label class="col-md-4">{{locale.LABEL_FILE_UPLOAD_FILE}}</label>
      <wms-file-upload [acceptType]="mimeType" ></wms-file-upload>
    </div>
  </form>
</wms-dialog-body>
<wms-dialog-footer>
  <!-- TODO: disabled="{{disableDialogActions}}"  -->
  <button class="cancel-action btn app-button btn-secondary" (click)="onCancel('uploadResourcesDialog')"><span class="btn-caption">{{locale.LABEL_CANCEL}}</span></button>
  <!-- TODO: disabled="{{disableDialogActions}}"  -->
  <button class="btn-primary ok-action btn app-button" (click)="uploadResource('uploadResourcesDialog', 'resourceUploadForm') "><span class="btn-caption">{{locale.LABEL_OK}}</span></button>
</wms-dialog-footer>
